import { ApiError } from './api';

/** Multipart upload with progress (XHR - fetch has no upload progress). */
export function uploadWithProgress<T>(
  url: string,
  file: File,
  fields: Record<string, string>,
  onProgress: (pct: number) => void,
): Promise<T> {
  return new Promise((resolve, reject) => {
    const fd = new FormData();
    for (const [k, v] of Object.entries(fields)) if (v !== '') fd.append(k, v);
    fd.append('file', file, file.name);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('X-Requested-With', 'fda-compliance');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress(Math.round((e.loaded / e.total) * 100));
    xhr.onerror = () => reject(new ApiError(0, 'NETWORK', 'Network error'));
    xhr.onload = () => {
      let body: unknown = null;
      try {
        body = xhr.responseText ? JSON.parse(xhr.responseText) : null;
      } catch {
        /* ignore */
      }
      if (xhr.status >= 200 && xhr.status < 300) resolve(body as T);
      else {
        const e = (body as { error?: { code?: string; message?: string; details?: unknown } } | null)?.error;
        reject(
          new ApiError(xhr.status, e?.code ?? `HTTP_${xhr.status}`, e?.message ?? xhr.statusText, e?.details),
        );
      }
    };
    xhr.send(fd);
  });
}
